import { HttpParams } from '@angular/common/http';

export const createRequestOption = (req?: any) => {
    const options = {};
    if (req) {
        const params: HttpParams = new HttpParams();
        params.set('page', req.page);
        params.set('size', req.size);
        if (req.sort) {
            params.set('sort', req.sort);
        }
        params.set('query', req.query);

        options['params'] = params;
    }
    return options;
};



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/model/request-util.ts